import type { Lang } from '../i18n/i18n';

export function parseDay(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function formatDay(iso: string, lang: Lang): string {
  return parseDay(iso).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, { day: 'numeric', month: 'long', year: 'numeric' });
}

export function daysUntil(iso: string): number {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((parseDay(iso).getTime() - today.getTime()) / 86400000);
}

export const orNull = (s: string) => (s.trim() ? s.trim() : null);
